'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { FooterContactItemProps } from './custom-footer';

import { Paragraph } from '../ui/paragraph';

export function FooterContactItem({ contact }: { contact: FooterContactItemProps }) {
  return (
    <>
      <Link
        prefetch={false}
        href={contact.href}
        target="_blank"
        rel="noopener noreferrer"
        className="hidden items-center justify-start gap-4 text-white transition-all hover:opacity-75 md:flex"
      >
        <Image src={contact.icon} alt={contact.value} width={24} height={24} />
        <Paragraph size="md" color="white">
          {contact.value}
        </Paragraph>
      </Link>
      <Link
        prefetch={false}
        href={contact.href}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-start gap-4 text-white transition-all hover:opacity-75 md:hidden"
      >
        <div className="flex h-10 w-10 items-center justify-center rounded-[5px] bg-white">
          <Image src={contact.icon} alt={contact.value} width={20} height={20} />
        </div>
        <p className="text-lg font-normal text-white">{contact.value}</p>
      </Link>
    </>
  );
}
